import router from "@/router";
import Geohash from "latlon-geohash";
import { Marker } from "mapbox-gl";

export default class Address {
  constructor(name, lat, lng, id) {
    this.id = id;
    this.name = name;
    this.lat = lat;
    this.lng = lng;
  }

  static fromGeoJSON(feature) {
    const id = feature.id;
    const lat = feature.geometry.coordinates[1];
    const lng = feature.geometry.coordinates[0];
    const name = feature.place_name;
    return new Address(name, lat, lng, id);
  }

  get geohash() {
    return Geohash.encode(this.lat, this.lng);
  }

  get slug() {
    return this.name.replace(/\s+/g, "-");
  }

  get marker() {
    const mark = new Marker({ title: this.name })
      .setLngLat([this.lng, this.lat]);
    mark.getElement().addEventListener("click", () => {
      router.push({ name: "Address", params: { geohash: this.geohash, slug: this.slug } });
    });
    return mark;
  }
}



// WEBPACK FOOTER //
// ./src/models/address.js